
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Die chinesische Studie zeigte zudem, dass bei 80,9% der Infizierten
  die Krankheit einen milden Verlauf nahm. Und selbst bei den schweren
  Fällen (13,8%) gab es keine Toten.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;